// const player = document.querySelector(".nr_cart_progress_checkmark");
// player.load("https://cdn.shopify.com/s/files/1/0741/8996/3571/files/Animation_-_1709712761018.json?v=1709713283");

$(document).on("mouseover",".nr_cart_item_remove",function() {
    $(this).addClass('active');
});
$(document).on("mouseleave",".nr_cart_item_remove",function() {
    $(this).removeClass('active');
});
 
function setDeliveryDate(){
  setTimeout(function(){
    var delivery_date = $('.delivery-hidden').attr('value');
    console.log(delivery_date);
    if (typeof(delivery_date) != 'undefined'){
      document.cookie = "deliveryDate="+delivery_date+"; expires=Thu, 1 Jan 2025 00:00:00 UTC; path=/";
    }
  },200);
  
}

function getDeliveryDate(){
  setTimeout(function(){
    var cookies = document.cookie.split(';');
    var delivery_date;
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].trim();
        if (cookie.indexOf('deliveryDate') != -1){
          delivery_date = cookie;
        }
      }
      if (typeof(delivery_date) != 'undefined'){
      delivery_date = delivery_date.replace('deliveryDate=', '');
      console.log(delivery_date),  'kookiai';
      }
  
      if (typeof(delivery_date) != 'undefined'){
        $('.nr_cart_footer_terms').show();
        $('.nr_cart_delivery_date_footer').html(delivery_date);
      }
      else{
        $('.nr_cart_footer_terms').hide();
      };
  },200);
}

setDeliveryDate();
getDeliveryDate();

function auraBundleChecker(){
  jQuery.getJSON('/cart.js', function (cart) {
    if (cart.item_count >= 1) {
      var auraPagalveId = 9091461808469;
      var auraPagalveQty = 0;

      var auraBundleTriggerId = 14869654765948;
      var auraBundleQty = 0;

      var needsToRemoveAura = 0;

      for (var i = 0; i < cart.items.length; i++) {

        if (cart.items[i].product_id == auraPagalveId) {
          auraPagalveQty += cart.items[i].quantity;
        }
        if (cart.items[i].product_id == auraBundleTriggerId) {
          auraBundleQty += cart.items[i].quantity;
        }

      }

      if (auraPagalveQty > 0){
        
          var divider = auraBundleQty / auraPagalveQty;
          if (divider == 1){
            needsToRemoveAura  = 0;
          }        
          else{
            needsToRemoveAura  = 1;
          }
      }
      else{
        needsToRemoveAura  = 0;
      }

      if (needsToRemoveAura  == 1){
        $('.nr_cart_checkout_btn').hide();
        $('.nr_cart_progress').html('Šis produktas negali būti perkamas atskirai nuo rinkinio');
        
      }
      else{
        $('.nr_cart_checkout_btn').show();
        $('.nr_cart_progress').html('<p></p><div class="nr_cart_progress_line"> <div class="nr_cart_progress_inner" style="width: 35%;"></div> </div>');
      }
    }
  });
}

function freeGiftFromOffer(){
  jQuery.getJSON("/cart.js", function (cart) {
    if (cart.item_count >= 1) {
      var giftTriggerId =  8628287668565;
      var giftTriggerQty = 0;
      var giftId = 46859972903253;
      var giftQty = 0;
      var emailGiftId = 46853219877189;
      var emailGiftQty = 0;

      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].product_id == giftTriggerId) {
          giftTriggerQty += cart.items[i].quantity;
        }
        if (cart.items[i].id == giftId) {
          giftQty += cart.items[i].quantity;
        }
        if (cart.items[i].id == emailGiftId) {
          emailGiftQty += cart.items[i].quantity;
        }

      }

      var updates = {};

      if (giftTriggerQty < 2){
        updates[giftId] = 0;
      }
      else if (giftTriggerQty == 2 || giftTriggerQty == 3){
        updates[giftId] = 1;
      }
      else if (giftTriggerQty > 3){
        updates[giftId] = 2;
      }

      console.log(giftTriggerQty, 'trigger');

      console.log(updates, 'updates');

      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {
            updates: updates
        },
        success: function(data) {
        // buildCart();
     }
    });
    }
  });
}

// function freeGiftFromOffer (){
//       jQuery.getJSON('/cart.js', function (cart) {
//         if (cart.item_count >= 1){

          // var giftBogoTrigger = 9089597800789;
          // var giftBogoTriggerQty = 0;
  
          // var giftBogoId = 49501948838229;
          // var giftBogoQty = 0;
            
          // var giftTriggerId = 8628287668565;
          // var giftTriggerId2 = 86282876685650000;
          // var giftTriggerQty = 0;
          // var giftTriggerQty2 = 0;
          // var giftId = 46859972903253;
          // var giftQty = 0;
          // var emailGiftId = 47119244558680;
          // var emailGiftQty = 0;

          // var giftTriggerQtymask = 0;
          // var giftTriggerQtycap = 0;
          // var giftTriggerQtyeucalipt = 0;
          // var giftTriggerComplectQty = 0; 
          // var giftTriggerQtymeschino = 0;
          
//           for (var i = 0; i < cart.items.length; i++) {
//             if(cart.items[i].product_id == giftTriggerId){
//               giftTriggerQty+=cart.items[i].quantity;
//             }
//             if(cart.items[i].product_id == giftTriggerId2){
//               giftTriggerQty2+=cart.items[i].quantity;
//             }
//             if(cart.items[i].id == giftId){
//               giftQty+=cart.items[i].quantity;
//             }
//             if(cart.items[i].id == emailGiftId){
//               emailGiftQty+=cart.items[i].quantity;
//             }

//             if (cart.items[i].id == giftBogoId) {
//               giftBogoQty += cart.items[i].quantity;
//             }
//             if (cart.items[i].product_id == giftBogoTrigger) {
//               giftBogoTriggerQty += cart.items[i].quantity;
//             }
//           }

//           var need_both  = 0;
        
//         if (
//           giftTriggerQtymask > 0 ||
//           giftTriggerQtycap > 0 ||
//           giftTriggerQtyeucalipt > 0 ||
//           giftTriggerComplectQty > 0
//         ) {
//           if (emailGiftQty > 0) {
//             var data = {
//               id: giftId,
//               quantity: 0,
//             };
//             if (giftQty == 0){
//               needs_change = 0;
//             }
//             else{
//               needs_change = 1;
//             }
//           } else {
//             var data = {
//               id: giftId,
//               quantity: 1,
//             };
//             if (giftQty == 1){
//               needs_change = 0;
//             }
//             else{
//               needs_change = 1;
//             }
//           }
//         }

//         if (
//           giftBogoTriggerQty < 1 &&
//           giftTriggerQty < 1 &&
//           giftTriggerQty2 < 1 &&
//           giftTriggerQtymask < 1 &&
//           giftTriggerQtycap < 1 &&
//           giftTriggerQtyeucalipt < 1 &&
//           giftTriggerComplectQty < 1 && 
//           giftTriggerQtymeschino < 1 
//         ) {
//           var data = {
//             id: giftId,
//             quantity: 0,
//           };
//           if (giftQty == 0){
//             needs_change = 0;
//           }
//           else{
//             needs_change = 1;
//           }
//         } 

//         else if (giftTriggerQty > 0 && giftTriggerQty < 4) {
//           if (emailGiftQty > 0) {
//             var data = {
//               id: giftId,
//               quantity: 0,
//             };
//             if (giftQty == 0){
//               needs_change = 0;
//             }
//             else{
//               needs_change = 1;
//             }
//           } else {
//             var data = {
//               id: giftId,
//               quantity: 1,
//             };
//             if (giftQty == 1){
//               needs_change = 0;
//             }
//             else{
//               needs_change = 1;
//             }
            
//           }
//         } 
//         else if (giftTriggerQty2 > 0 && giftTriggerQty2 < 4) {
//           if (emailGiftQty > 0) {
//             var data = {
//               id: giftId,
//               quantity: 0,
//             };
//             if (giftQty == 0){
//               needs_change = 0;
//             }
//             else{
//               needs_change = 1;
//             }
//           } else {
//             var data = {
//               id: giftId,
//               quantity: 1,
//             };
//             if (giftQty == 1){
//               needs_change = 0;
//             }
//             else{
//               needs_change = 1;
//             }
//           }
//         } 
//         else if (giftTriggerQtymeschino > 0 && giftTriggerQtymeschino < 4) {
//           if (emailGiftQty > 0) {
//             var data = {
//               id: giftId,
//               quantity: 0,
//             };
//             if (giftQty == 0){
//               needs_change = 0;
//             }
//             else{
//               needs_change = 1;
//             }
//           } else {
//             var data = {
//               id: giftId,
//               quantity: 1,
//             };
//             if (giftQty == 1){
//               needs_change = 0;
//             }
//             else{
//               needs_change = 1;
//             }
//           }
//         } 
//         else if (giftTriggerQty > 3) {
//           if (emailGiftQty > 0) {
//             var data = {
//               id: giftId,
//               quantity: 1,
//             };
//             if (giftQty == 1){
//               needs_change = 0;
//             }
//             else{
//               needs_change = 1;
//             }
//           } else {
//             var data = {
//               id: giftId,
//               quantity: 2,
//             };

//             if (giftQty == 2){
//               needs_change = 0;
//             }
//             else{
//               needs_change = 1;
//               need_both  = need_both + 1;
//             }
//           }
//         }
//         else if (giftTriggerQty2 > 3) {
//           if (emailGiftQty > 0) {
//             var data = {
//               id: giftId,
//               quantity: 1,
//             };
//             if (giftQty == 1){
//               needs_change = 0;
//             }
//             else{
//               needs_change = 1;
//             }
//           } else {
//             var data = {
//               id: giftId,
//               quantity: 2,
//             };
//             if (giftQty == 2){
//               needs_change = 0;
//             }
//             else{
//               needs_change = 1;
//               need_both  = need_both + 1;
//             }
//           }
//         }
//         else if (giftTriggerQtymeschino > 3) {
//           if (emailGiftQty > 0) {
//             var data = {
//               id: giftId,
//               quantity: 1,
//             };
//             if (giftQty == 1){
//               needs_change = 0;
//             }
//             else{
//               needs_change = 1;
//             }
//           } else {
//             var data = {
//               id: giftId,
//               quantity: 2,
//             };
//             if (giftQty == 2){
//               needs_change = 0;
//             }
//             else{
//               needs_change = 1;
//             }
//           }
//         }
        

//         var needs_changebog = 0;

//         if (giftTriggerQty  >= 2){
//           if (giftTriggerQty < 4){
           
//             if (giftBogoQty < 1){
//               var data_bogo = {
//                 id: giftBogoId,
//                 quantity: 1,
//               };
//               needs_changebog = 1;
//             }
//             else{
//               needs_changebog = 0;
//             }
//           }
//           else if (giftTriggerQty >= 4 && giftTriggerQty < 6){
//             var data_bogo = {
//               id: giftBogoId,
//               quantity: 2,
//             };
//             if (giftBogoQty == 2 || giftBogoQty > 2){
//               needs_changebog = 0;
//             }
//             else{
//               needs_changebog = 1;
//               need_both  = need_both + 1;
//             }

//             var data_arr = [];
//             data_arr.push({
//               id: giftId,
//               quantity: 1,
//             });
//             data_arr.push({
//               id: giftBogoId,
//               quantity: 1,
//             });
//           }
//           else if (giftTriggerQty >= 6){
//             var bogoQty = Math.floor(giftTriggerQty/2);
//             // console.log(bogoQty, 'BOGO QTY');
//             var data_bogo = {
//               id: giftBogoId,
//               quantity: bogoQty,
//             };
//             if (giftBogoQty == bogoQty || giftBogoQty > bogoQty){
//               needs_changebog = 0;
//             }
//             else{
//               needs_changebog = 1;
//             }
//           }
//         }
//         else{
//           if (giftBogoQty == 0){
//             needs_changebog = 0;
//           }
//           else{
//             // var data = {
//             //   id: giftBogoId,
//             //   quantity: 0,
//             // };
//             needs_changebog = 0;
//           }
//         }

//         console.log(data, need_both, needs_change, needs_changebog, 'NEEDS CHANGE IDENTIFICATOR');

//         if ( need_both > 1 ){
//         // console.log('both changes');
//           $.ajax({
//             type: "POST",
//             url: "/cart/add.js",
//             data: {
//               items: data_arr,
//             },
//             dataType: "json",
//             success: function (data) {
//               console.log("Changed Gift Quantity");
//             },
//           }); 
//         }
//         else{
//           if (needs_change == 1){
//             if (giftQty > 0) {
//               jQuery.ajax({
//                 type: "POST",
//                 url: "/cart/change.js",
//                 data: data,
//                 dataType: "json",
//                 success: function() {
//                     console.log("Changed Gift Quantity");
//                     // If tracking is allowed and the request was successful,
//                     // you may trigger your tracking events here if needed.
//                 }
//               });
//             } else {
//               jQuery.ajax({
//                 type: "POST",
//                 url: "/cart/add.js",
//                 data: data,
//                 dataType: "json",
//                 success: function () {
//                   console.log("Added Gift Quantity");
//                 },
//               });
//             }
//           }
  
  
//           if (needs_changebog == 1){
            
//             if (giftBogoQty > 0) {

//               // console.log(data, 'DATA TO BE CHANGED');

//               jQuery.ajax({
//                 type: "POST",
//                 url: "/cart/change.js",
//                 data: data_bogo,
//                 dataType: "json",
//                 success: function() {
//                     console.log("Changed Gift Quantity");
//                     // If tracking is allowed and the request was successful,
//                     // you may trigger your tracking events here if needed.
//                 }
//               });
//             } else {
//               jQuery.ajax({
//                 type: "POST",
//                 url: "/cart/add.js",
//                 data: data_bogo,
//                 dataType: "json",
//                 success: function () {
//                   console.log("Added Gift Quantity");
//                 },
//               });
//             }
//           }
//         }
//         }
//       });
//     }


// function freeGiftFromOffer (){
//   jQuery.getJSON('/cart.js', function (cart) {
//     if (cart.item_count >= 1){
//       console.log(cart);


//       var giftBogoTrigger = 9226008461637;
//       var giftBogoTriggerQty = 0;

//       var giftBogoId = 49501948838229;
//       var giftBogoQty = 0;

//       var giftTriggerId = 8554299556165;
//       var upsellGiftTrigger = 8984911348044;
//       var upsellGiftTriggerQty = 0;

//       var upsellGift = 8984915050828;
//       var upsellGiftQty = 0;
//       var upsellGiftVariant;

//       var upsellMaskIdGrey = 47718307660108;
//       var upsellMaskIdCream = 47718307692876;
//       var upsellMaskIdPink = 47718307725644;
//       var upsellMaskGreyQty = 0;
//       var upsellMaskCreamQty = 0;
//       var upsellMaskPinkQty = 0;
      
//       var giftTriggerQty = 0;
//       var giftId = 46859972903253;
//       var giftQty = 0;



//       var giftBogoTrigger = 9089597800789;
//       var giftBogoTriggerQty = 0;

//       var giftBogoId = 49501948838229;
//       var giftBogoQty = 0;
        
//       var giftTriggerId = 8628287668565;
//       var giftTriggerId2 = 86282876685650000;
//       var giftTriggerQty = 0;
//       var giftTriggerQty2 = 0;
//       var giftId = 46859972903253;
//       var giftQty = 0;
//       var emailGiftId = 47119244558680;
//       var emailGiftQty = 0;

//       var giftTriggerQtymask = 0;
//       var giftTriggerQtycap = 0;
//       var giftTriggerQtyeucalipt = 0;
//       var giftTriggerComplectQty = 0; 
//       var giftTriggerQtymeschino = 0;
      
//       for (var i = 0; i < cart.items.length; i++) {

//         if(cart.items[i].product_id == upsellGift){
//           upsellGiftVariant = cart.items[i].id;
//           upsellGiftQty+=cart.items[i].quantity;
//         }
        
//         if(cart.items[i].product_id == giftTriggerId){
//           giftTriggerQty+=cart.items[i].quantity;
//         }
//         if(cart.items[i].id == giftId){
//           giftQty+=cart.items[i].quantity;
//         }

//         if(cart.items[i].id == upsellMaskIdGrey){
//           upsellMaskGreyQty+=cart.items[i].quantity;
//         }
//         if(cart.items[i].id == upsellMaskIdCream){
//           upsellMaskCreamQty+=cart.items[i].quantity;
//         }
//         if(cart.items[i].id == upsellMaskIdPink){
//           upsellMaskPinkQty+=cart.items[i].quantity;
//         }

//         if (cart.items[i].id == giftBogoId) {
//           giftBogoQty += cart.items[i].quantity;
//         }
//         if (cart.items[i].product_id == giftBogoTrigger) {
//           giftBogoTriggerQty += cart.items[i].quantity;
//         }
          
//       }

//       console.log(upsellGiftVariant, upsellGiftQty,upsellGiftTriggerQty, 'eukalipts');

//       var need_both  = 0;
//       var cart_cleared = 0;
//       var needs_change = 0;

//       var needAddDovana = 0;
//       var needAddDetergent = 0;
//       var needAddAbu = 0;
      
//       var data = [];

//       if (giftTriggerQty < 1){
//         cart_cleared = 1;
//         var updates = {
//                 "46859972903253": 0, 
//                 "49501948838229": 0 
//             };
//       }
//         // Jei 1
//       else if (giftTriggerQty == 1 ){
//         console.log('here');
        
//         if (giftQty < 1 ){
//            needAddDovana = 1;
//             data.push({
//               id: giftId,
//               quantity: 1,
//             });
//          }
//          else{
//            needs_change = 1;
//             data.push({
//               id: giftId,
//               quantity: 1,
//             });
//             data.push({
//               id: giftBogoId,
//               quantity: 0,
//             });
//            var updates = {
//                 "46859972903253": 1, 
//                 "49501948838229": 0 
//             };
//          }
//       }
//         // Jei 2
//       else if (giftTriggerQty == 2  || giftTriggerQty == 3){
//         console.log('here');
//         if (giftQty < 1 && giftBogoQty < 1){
//            needAddAbu = 1;
//             data.push({
//               id: giftBogoId,
//               quantity: 1,
//             });
//             data.push({
//               id: giftId,
//               quantity: 1,
//             });
//          }
//          else if (giftQty == 1 && giftBogoQty < 1){
//            needAddDetergent = 1;
//             data.push({
//               id: giftBogoId,
//               quantity: 0,
//             });
//          }
//          else if (giftQty < 1 && giftBogoQty == 1){
//            needAddDovana = 1;
//             data.push({
//               id: giftId,
//               quantity: 1,
//             });
//          }
//          else{
//            needs_change = 1;
//             data.push({
//               id: giftBogoId,
//               quantity: 0,
//             });
//             data.push({
//               id: giftId,
//               quantity: 1,
//             });
//             var updates = {
//                 "46859972903253": 1, 
//                 "49501948838229": 0  
//             };
//          }       
//       }
//       else if (giftTriggerQty > 3){
//         var giftBogoQtyNew = Math.floor(giftTriggerQty / 2);


//          if (giftQty < 1 && giftBogoQty < 1){
//            needAddAbu = 1;
//             data.push({
//               id: giftBogoId,
//               quantity: 2,
//             });
//             data.push({
//               id: giftId,
//               quantity: 2,
//             });
//          }
//          else if (giftQty == 2 && giftBogoQty < 1){
//            needAddDetergent = 1;
//             data.push({
//               id: giftBogoId,
//               quantity: 2,
//             });
//          }
//          else if (giftQty < 1 && giftBogoQty == giftBogoQtyNew){
//            needAddDovana = 1;
//             data.push({
//               id: giftId,
//               quantity: 1,
//             });
//          }
//          else{
//            needs_change = 1;
//             data.push({
//               id: giftBogoId,
//               quantity: 0,
//             });
//             data.push({
//               id: giftId,
//               quantity: 1,
//             });
//            var updates = {
//                 "46859972903253": 1, 
//                 "49501948838229": 2 
//             };
//          }
        
//       }

//       if (cart_cleared == 1){
//         // $.ajax({
//         //   type: 'POST',
//         //   url: '/cart/clear.js',
//         //   dataType: 'json',
//         //   success: function(data) {
//         //     console.log('Success, cleare cart');
//         //   }
//         // });
//          $.ajax({
//               type: 'POST',
//               url: '/cart/update.js',
//               data: {
//                   updates: updates
//               },
//               dataType: 'json',
//               async: false // Note: async:false has been deprecated in jQuery
//           });
//       }
      


//       console.log(data, needAddAbu, needAddDetergent, needAddDovana, needs_change);

//       if (needAddAbu == 1){
//         $.ajax({
//           type: "POST",
//           url: "/cart/add.js",
//           data: {
//             items: data,
//           },
//           dataType: "json",
//           success: function (data) {
//             // Do something on success
//             console.log('Prideti abu');
//           },
//         }); 
//       }
//       if (needAddDetergent == 1){
//           $.ajax({
//             type: "POST",
//             url: "/cart/add.js",
//             data: {
//               items: data,
//             },
//             dataType: "json",
//             success: function (data) {
//               // Do something on success
//               console.log('Pridetas deterg');
//             },
//           }); 
//        }
//        if (needAddDovana == 1){
//           $.ajax({
//             type: "POST",
//             url: "/cart/add.js",
//             data: {
//               items: data,
//             },
//             dataType: "json",
//             success: function (data) {
//               // Do something on success
//               console.log('Prideta dovana');
//             },
//           }); 
//         }
//         if (needs_change == 1){

//           $.ajax({
//               type: 'POST',
//               url: '/cart/update.js',
//               data: {
//                   updates: updates
//               },
//               dataType: 'json',
//               async: false // Note: async:false has been deprecated in jQuery
//           });
//         }
  
//     }
//   });
// }

function buildCart(){
    auraBundleChecker();
    // freeGiftFromOffer();
    setTimeout(function () {
        var cart_item = [];
        var summary_item = [];
        jQuery.getJSON("/cart.js", function (cart) {
          console.log(cart);
  
          var compare_price_integer = 0;
          var currency = "€";
          var discounts = 0;


          // cart summary variables
          var pagalves = 0;
          var kepures = 0;
          var kaukes = 0;
          var dovana = 0;
          var eukaliptas = 0;
          var skalbiklis = 0;

          var pagalvesPrice = 0;
          var kaukesPrice = 0;
          var kepuresPrice = 0;
          var eukaliptasPrice = 0;

          var pagalvesId = 'naravne-svile';
          var kepuresId = 'spalna-kapa';
          var kaukesId = 'maska';
          var dovanaId = 'gift';
          var eukaliptasId = 'evkaliptusa';
          var skalbiklisId = 'noreo-okolju-prijazni-pralni-listici';

          for (var i = 0; i < cart.items.length; i++) {
            if (String(cart.items[i].handle).indexOf(pagalvesId) != -1){
                pagalves = pagalves + cart.items[i].quantity;
                pagalvesPrice = pagalvesPrice + cart.items[i].line_price;
            }
            if (String(cart.items[i].handle).indexOf(kepuresId) != -1){
                kepures = kepures + cart.items[i].quantity;
                kepuresPrice = kepuresPrice + cart.items[i].line_price;
            }
            if (String(cart.items[i].handle).indexOf(skalbiklisId) != -1){
                skalbiklis = skalbiklis + cart.items[i].quantity;
            }
            if (String(cart.items[i].handle).indexOf(kaukesId) != -1){
                kaukes = kaukes + cart.items[i].quantity;
                kaukesPrice = kaukesPrice + cart.items[i].line_price;
            }
            if (String(cart.items[i].handle).indexOf(dovanaId) != -1){
                dovana = dovana + cart.items[i].quantity;
            }
            if (String(cart.items[i].handle).indexOf(eukaliptasId) != -1){
                eukaliptas = eukaliptas + cart.items[i].quantity;
                eukaliptasPrice = eukaliptasPrice + cart.items[i].line_price;
            }
          }

          for (var i = 0; i < cart.items.length; i++) {

            var quantity = cart.items[i].quantity;
            var price = ((cart.items[i].price * quantity) / 100).toFixed(2);  
            var compare_price = ""; 
  
            // Price check
            $(".All_product_selector__js").each(function () {
              if ($(this).attr("data-id") == cart.items[i].id) {
                compare_price = $(this).attr("data-compare-price");
              }
            });
             compare_price = ((compare_price * quantity) / 100).toFixed(2);
            compare_price = parseFloat(compare_price);
            compare_price_integer = compare_price_integer + compare_price;
  

            if (compare_price != "0.00") {
              console.log('420');
              if (cart.items[i].final_price == cart.items[i].original_price) {
                console.log('422');
                if (isNaN(compare_price)) {
                  var price_line = price + " " + currency;
                } else {
                  console.log('426');
                  var price_line =
                  price + " " + currency + "<s>" +  compare_price + " " + currency + "</s>";
 
                  price_integer = quantity * cart.items[i].final_price;
                }
              } else if (
                cart.items[i].final_price < cart.items[i].original_price
              ) {
                console.log('435');
                price = (cart.items[i].final_line_price / 100).toFixed(2);
                var price_line =
                price + " " + currency + "<s>" + compare_price + " " + currency + "</s>";

                price_integer = quantity * cart.items[i].final_price;
              }
            } else {
              console.log('440');
              if (cart.items[i].final_price == cart.items[i].original_price) {
                var price_line = price + " " + currency;
                console.log('446');
                price_integer = quantity * cart.items[i].final_price;
                compare_price_integer = compare_price_integer + cart.items[i].original_line_price/100;
              } else if (
                cart.items[i].final_price < cart.items[i].original_price
              ) {
                console.log('451');
                price = (cart.items[i].final_line_price / 100).toFixed(2);
                var price_line =
                price + " " + currency +"<s>" + ((cart.items[i].original_line_price/100).toFixed(2)) + " " + currency + "</s>";

                price_integer = quantity * cart.items[i].final_price;
                compare_price_integer = compare_price_integer + cart.items[i].original_line_price/100;
              }
            }
  
            // Variant Title check
            var variant_option1 = cart.items[i].variant_options[0];
            var variant_option2 = cart.items[i].variant_options[1];
            
            if (variant_option1 == 'Default Title' || typeof(variant_option1) == 'undefined'){
                var cart_option1_line = '';
            }
            else{
                var cart_option1_line = '<p class="nr_cart_item_variant">Barva: <span>'+variant_option1+'</span></p>';
            }

            if (variant_option2 == 'Default Title' || typeof(variant_option2) == 'undefined' ){
                var cart_option2_line = '';
            }
            else{
                var cart_option2_line = '<p class="nr_cart_item_variant">Velikost: <span>'+variant_option2+'</span></p>';
            }
        

            if (cart.items[i].id == '46859972903253'){
              cart_item[i] =
                `
                <div class="nr_cart_item" data-id="`+cart.items[i].id+`">
                    <div>
                        <img src="`+cart.items[i].image+`">
                    </div>
                    <div>
                        <p class="nr_cart_item_title">`+cart.items[i].product_title+`</p>
                        `+ cart_option1_line +`
                        `+ cart_option2_line +`
                        <p class="nr_cart_item_price">`+ price_line +`</p>
                    </div>
                    <div>
                        <div class="nr_cart_item_remove">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 8.772 10.797">
                                <path id="Icon_metro-bin" data-name="Icon metro-bin" d="M5.174,5.3V12.05a.677.677,0,0,0,.675.675h6.073a.677.677,0,0,0,.675-.675V5.3H5.174ZM7.2,11.375H6.523V6.652H7.2Zm1.35,0H7.873V6.652h.675Zm1.35,0H9.222V6.652H9.9Zm1.35,0h-.675V6.652h.675Zm1.518-8.1H10.572V2.434a.508.508,0,0,0-.506-.506H7.7a.508.508,0,0,0-.506.506v.843H5a.508.508,0,0,0-.506.506v.843h8.772V3.784A.508.508,0,0,0,12.765,3.278Zm-2.868,0H7.873V2.611H9.9v.666Z" transform="translate(-4.499 -1.928)" fill="#c3c3c3"/>
                            </svg>
                            <span class="loader"></span>                  
                        </div>
                        <div class="nr_cart_item_quantity_cont">
                            
                            <div class="nr_cart_quantity_value">`+cart.items[i].quantity+`</div>
                            
                        </div>
                    </div>
                </div>
                      `;
            }
            else if (cart.items[i].product_id == '9483781472597' || cart.items[i].product_id == '9481526509909'){
              cart_item[i] =
                `
                <div class="nr_cart_item removableonce" data-product-id="`+cart.items[i].product_id+`" data-id="`+cart.items[i].id+`">
                    <div>
                        <img src="`+cart.items[i].image+`">
                    </div>
                    <div>
                        <p class="nr_cart_item_title">`+cart.items[i].product_title+`</p>
                        `+ cart_option1_line +`
                        `+ cart_option2_line +`
                        <p class="nr_cart_item_price">`+ price_line +`</p>
                    </div>
                    <div>
                        <div class="nr_cart_item_remove nr_remove_all_kit">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 8.772 10.797">
                                <path id="Icon_metro-bin" data-name="Icon metro-bin" d="M5.174,5.3V12.05a.677.677,0,0,0,.675.675h6.073a.677.677,0,0,0,.675-.675V5.3H5.174ZM7.2,11.375H6.523V6.652H7.2Zm1.35,0H7.873V6.652h.675Zm1.35,0H9.222V6.652H9.9Zm1.35,0h-.675V6.652h.675Zm1.518-8.1H10.572V2.434a.508.508,0,0,0-.506-.506H7.7a.508.508,0,0,0-.506.506v.843H5a.508.508,0,0,0-.506.506v.843h8.772V3.784A.508.508,0,0,0,12.765,3.278Zm-2.868,0H7.873V2.611H9.9v.666Z" transform="translate(-4.499 -1.928)" fill="#c3c3c3"/>
                            </svg>
                            <span class="loader"></span>                  
                        </div>
                        <div class="nr_cart_item_quantity_cont">
                            
                            <div class="nr_cart_quantity_value">`+cart.items[i].quantity+`</div>
                            
                        </div>
                    </div>
                </div>
                      `;
            }
            else{
              cart_item[i] =
                `
                <div class="nr_cart_item" data-id="`+cart.items[i].id+`">
                    <div>
                        <img src="`+cart.items[i].image+`">
                    </div>
                    <div>
                        <p class="nr_cart_item_title">`+cart.items[i].product_title+`</p>
                        `+ cart_option1_line +`
                        `+ cart_option2_line +`
                        <p class="nr_cart_item_price">`+ price_line +`</p>
                    </div>
                    <div>
                        <div class="nr_cart_item_remove">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 8.772 10.797">
                                <path id="Icon_metro-bin" data-name="Icon metro-bin" d="M5.174,5.3V12.05a.677.677,0,0,0,.675.675h6.073a.677.677,0,0,0,.675-.675V5.3H5.174ZM7.2,11.375H6.523V6.652H7.2Zm1.35,0H7.873V6.652h.675Zm1.35,0H9.222V6.652H9.9Zm1.35,0h-.675V6.652h.675Zm1.518-8.1H10.572V2.434a.508.508,0,0,0-.506-.506H7.7a.508.508,0,0,0-.506.506v.843H5a.508.508,0,0,0-.506.506v.843h8.772V3.784A.508.508,0,0,0,12.765,3.278Zm-2.868,0H7.873V2.611H9.9v.666Z" transform="translate(-4.499 -1.928)" fill="#c3c3c3"/>
                            </svg>
                            <span class="loader"></span>                  
                        </div>
                        <div class="nr_cart_item_quantity_cont">
                            <div class="nr_cart_quantity_minus"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/></svg></div>
                            <div class="nr_cart_quantity_value">`+cart.items[i].quantity+`</div>
                            <div class="nr_cart_quantity_plus"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"/></svg></div>
                        </div>
                    </div>
                </div>
                      `;
            }
            

          }

         
          if (cart.item_count == 0) {
            $('cart-drawer-content').hide();
            $('.nr_cart_progress').hide();
            $('.nr_cart_footer').hide();
            $(".cart-count-bubble").hide();
          }
          else if (cart.item_count >= 1) { 

            $(".cart-count-bubble span").text(cart.item_count);
            $(".cart-count-bubble").show();
            $('cart-drawer-content').show();
            $('.nr_cart_footer').show();
            $('.nr_cart_progress').show();
            $('.nr_cart_drawer_content__js').html(cart_item);


            var cart_total = cart.total_price;

            if ((cart_total / 100) == compare_price_integer){
              setTimeout(function(){
                $('.subtotal .nr_cart_summary_prices s').hide();
                $('.nr_cart_total .nr_cart_summary_prices s').hide();
              },50);
              
            }
            var cart_total_sub = (cart_total/ 100).toFixed(2);
            var compare_price_integer_sub = compare_price_integer.toFixed(2);
            
            // Shipping
            if (cart_total > 5900){
                $('.nr_cart_summary_line[data="shipping"] .nr_cart_summary_prices').html('0.00 €<s>3.50 €</s>');
            }
            else{
              $('.nr_cart_summary_line[data="shipping"] .nr_cart_summary_prices').html('3.50 €');
              cart_total = cart_total + 250;
            }
            cart_total = (cart_total/ 100).toFixed(2);
            compare_price_integer = compare_price_integer + 3.50;
            compare_price_integer = compare_price_integer.toFixed(2);

            $('.nr_cart_summary_line.subtotal .nr_cart_summary_prices').html( cart_total_sub + ' ' + currency + ' <s>'+compare_price_integer_sub+ ' ' + currency +'</s>');
            $('.nr_cart_summary_line.nr_cart_total .nr_cart_summary_prices').html( cart_total + ' ' + currency + ' <s>'+compare_price_integer+ ' ' + currency +'</s>');

            $('.nr_cart_upsell_only_pillow').hide();

            $('.nr_cart_summary_line[data="dovana"]').hide();
            if (pagalves > 0){
                $('.nr_cart_upsell_only_pillow').css('display', 'flex');
                var pagalvesUpsellPrice = parseFloat($('.nr_cart_upsell_only_pillow .nr_pillow_upsell_price').attr('data-price'));
                var pagalvesForecastPrice = pagalvesPrice + pagalvesUpsellPrice;
                console.log(pagalvesPrice, '   ', pagalvesForecastPrice);
                if (pagalves == 2){
                  pagalvesForecastPrice = pagalvesForecastPrice * 0.9;
                }
                else if (pagalves > 3){
                  pagalvesForecastPrice = pagalvesForecastPrice * 0.85;
                }
                pagalvesForecastPrice = ((pagalvesForecastPrice - pagalvesPrice)/100).toFixed(2);

                $('.nr_pillow_upsell_save__js').html(pagalvesForecastPrice + ' ' + currency);

            }
            if (dovana > 0){
                $('.cart_summary_items__js .nr_cart_summary_line[data="dovana"]').css('display', 'flex'); 
                $('.cart_summary_items__js .nr_cart_summary_line[data="dovana"]').find('.nr_cart_summary_line__qty').html(dovana);
            }

            // Progress calculation and upsells logic
            cartUpsellsAndProgress(pagalves, kaukes, kepures, eukaliptas, skalbiklis);
          }
        });
  
    }, 1000);
}


buildCart();

$(document).on("click",".nr_cart_quantity_plus",function() {
    $(this).closest('.nr_cart_item').addClass('loading');

    var data_id = $(this).closest('.nr_cart_item').attr('data-id');
    var data_qty = parseFloat($(this).closest('.nr_cart_item').find('.nr_cart_quantity_value').html());

    data_qty++;

    var data = {
        id: data_id,
        quantity: data_qty,
      };

      console.log(data, '   data');
      jQuery.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: data,
        dataType: "json",
        success: function () {
          console.log(data);
          buildCart();
          setTimeout(function(){
            $('.nr_cart_item').removeClass('loading');
          },1500);
        },
    });
});

$(document).on("click",".nr_cart_quantity_minus",function() {

    $(this).closest('.nr_cart_item').addClass('loading');

    var data_id = $(this).closest('.nr_cart_item').attr('data-id');
    var data_qty = parseFloat($(this).closest('.nr_cart_item').find('.nr_cart_quantity_value').html());

    data_qty--;

    var data = {
        id: data_id,
        quantity: data_qty,
      };

      console.log(data, '   data');
      jQuery.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: data,
        dataType: "json",
        success: function () {
          console.log(data);
          buildCart();
          setTimeout(function(){
            $('.nr_cart_item').removeClass('loading');
          },1500);
        },
    });
});


$(document).on("click",".nr_cart_item_remove",function() {

    $(this).closest('.nr_cart_item').addClass('loading');

    var data_id = $(this).closest('.nr_cart_item').attr('data-id');
    var data_qty = 0;

    var data = {
        id: data_id,
        quantity: data_qty,
      };

      console.log(data, '   data');
      if ($(this).hasClass('nr_remove_all_kit')){

      var update1 = String($('.removableonce[data-product-id="9483781472597"]').attr('data-id'));
      var update2 = String($('.removableonce[data-product-id="9481526509909"]').attr('data-id'));

      console.log(update1, update2);


      var updates = {};
      updates[update1] = 0;
      updates[update2] = 0;

      
      $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: {
              updates: updates
          },
          success: function(data) {
          buildCart();
          setTimeout(function(){
            $('.nr_cart_item').removeClass('loading');
          },1500);
       }
      });
    }
    else{
      console.log(data, '   data');
      jQuery.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: data,
        dataType: "json",
        success: function () {
          console.log(data);
          buildCart();
          setTimeout(function(){
            $('.nr_cart_item').removeClass('loading');
          },1500);
        },
    });
    }
});


$('.header__icon').click(function(evt){
    evt.preventDefault();

    $('.nr_cart_drawer_outer').css('display', 'flex');

    setTimeout(function(){
        $('.nr_cart_drawer_outer').addClass('active');
        $("body").addClass("Overflow_hidden");
        $("body").addClass("overflow-hidden");

    },100);
});


$('.nr_cart_goback').click(function(){
    $('.nr_cart_drawer_outer').removeClass('active');

    setTimeout(function(){
        $('.nr_cart_drawer_outer').hide();
        $("body").removeClass("Overflow_hidden");
        $("body").removeClass("overflow-hidden");
    },300);
});

$('.nr_cart_drawer_outer').click(function(){  
  if (!$(event.target).closest('.nr_cart_drawer').length) {
    $('.nr_cart_drawer_outer').removeClass('active');

    setTimeout(function(){
        $('.nr_cart_drawer_outer').hide();
        $("body").removeClass("Overflow_hidden");
        $("body").removeClass("overflow-hidden");
    },300);
  }
});

$(".Bt_atc_button").click(function () {
  $(".Bt_atc_button").text("Odota...");
  var items = [];
  $(".BT_cell.active").each(function () {
    var currentId = $(this).find(".price_line.active").attr("data-id");
    items.push({ id: currentId, quantity: 1 });
  });

  console.log(items);

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      items: items,
    },
    dataType: "json",
    success: function (data) {
      // Do something on success
      console.log(data);
      buildCart();
      setTimeout(function () {
        $('.nr_cart_drawer_outer').css('display', 'flex');

        setTimeout(function(){
            $('.nr_cart_drawer_outer').addClass('active');
            $("body").addClass("Overflow_hidden");
            $("body").addClass("overflow-hidden");
          $(".Bt_atc_button").text("Naročite paket");
        },100);
      }, 1000);
    },
  });
});

$(".Product_atc_button").click(function () {
    if ($(this).attr("data-stock") == "1") {
      var mode = $(this).attr("data-mode");
      var modeGift = $(this).attr('data-detergent-add');
      if (mode == "classic") {
        if (modeGift == 'true'){
          // addClassicItemDetergent();
          addClassicItem();
        }
        else{
          addClassicItem();
        }
      } else if (mode == "b3g1") {
        add_b3g1();
      } 
      else if (mode == 'pilnas_eucalipt'){
        addPilnasEucalipt();
      }
      else if (mode == "eucalipt") {
        if ($(".Product_upsell_eucalipt_note").hasClass("active")) {
          addEucaliptBundle();
        } else {
          addClassicItem();
        }
      }
      else if(mode == 'eukalipt_piilow_kit'){
        addEukaliptPillowUpsell();
      }
    }
  });




    function getPagalveId(){
      var id;
      var size = $('.pep_size_cell.active').attr('data-title');
      var color = $('.Color_selector input:checked').attr('handle-value');
      
      
      console.log(fullTitle);
      if (color == 'kremveida'){
        color = 'krema';
      }
      if (color == 'gaisi-peleks'){
        color = 'gaisi-peleka';
      }
      var fullTitle = color + '-' + size;
      $('.ppev__js').each(function(){
        if ($(this).attr('data-title') == fullTitle){
          id = $(this).attr('data-id');
        }
      });
    
      console.log(id);
    
      return id;
    }
  function addPilnasEucalipt(){
    $(".Product_atc_button").text("Pagaidiet...");
    var itemsToAdd = []; 
    var mainItemId = $("");
    var mainItemId = $(".product-variant-id").val();
    var pagalveId = getPagalveId();
  
    itemsToAdd.push({ id: mainItemId, quantity: 1 });
    itemsToAdd.push({ id: pagalveId, quantity: 2 });
  
    console.log(itemsToAdd);
  
    if (itemsToAdd.length > 0) {
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          items: itemsToAdd,
        },
        dataType: "json",
        success: function () {
          buildCart();
  
          $("body").addClass("Overflow_hidden");
          $("body").addClass("overflow-hidden");
          $('.nr_cart_drawer_outer').css('display', 'flex');
  
          setTimeout(function(){
              $('.nr_cart_drawer_outer').addClass('active');
          },100);
        },
      });
    }
    setTimeout(function () {
      $(".product-form .Product_atc_button").text("Dodaj v košarico");
    }, 1000);
  
  }

  function add_b3g1() {
    var activeSelectors = 0;
    $(".b3g1_selector_cell").each(function () {
      if ($(this).hasClass("active")) {
        activeSelectors++;
      }
    });
    console.log(activeSelectors);
    if (activeSelectors > 0){
      $(".Product_atc_button").text("Počakajte...");
      console.log("Added b3g1");
      var itemsToAdd = [];
      var data_mode = $(".b3g1_selector_cell.active").attr("data");
      if (data_mode == "1offer") {
        var selected_color1 = $(".Selector_buy_1")
          .find(".Product_variant_show_off_bubble.active")
          .attr("data-handle");
        var selected_size1 = $(".Selector_buy_1")
          .find(".Product_variant_size_selector_cell.active")
          .attr("data-title");
        var full_title = selected_color1 + "-" + selected_size1;
        var currentId;
        $(".Product_form_variant_checker__js").each(function () {
          if ($(this).attr("data-handle") == full_title) {
            currentId = $(this).attr("data-id");
          }
        });
        itemsToAdd.push({ id: currentId, quantity: 1 });
      }
      if (data_mode == "2offer") {
        var selected_color1 = $(".Selector_buy_2")
          .find(".Selector_buy_21.Product_variant_show_off_bubble.active")
          .attr("data-handle");
        var selected_size1 = $(".Selector_buy_2")
          .find(".Selector_buy_21.Product_variant_size_selector_cell.active")
          .attr("data-title");
        var full_title = selected_color1 + "-" + selected_size1;
        var currentId;
        $(".Product_buy2_variant_checker__js").each(function () {
          if ($(this).attr("data-handle") == full_title) {
            currentId = $(this).attr("data-id");
          }
        });
  
        var selected_color2 = $(".Selector_buy_2")
          .find(".Selector_buy_22.Product_variant_show_off_bubble.active")
          .attr("data-handle");
        var selected_size2 = $(".Selector_buy_2")
          .find(".Selector_buy_22.Product_variant_size_selector_cell.active")
          .attr("data-title");
        var full_title2 = selected_color2 + "-" + selected_size2;
        var currentId2;
        $(".Product_buy2_variant_checker__js").each(function () {
          if ($(this).attr("data-handle") == full_title2) {
            currentId2 = $(this).attr("data-id");
          }
        });
        itemsToAdd.push({ id: currentId, quantity: 1 });
        itemsToAdd.push({ id: currentId2, quantity: 1 });
      }
      if (data_mode == "4offer") {
        var selected_color1 = $(".Selector_buy_4")
          .find(".Selector_buy_41.Product_variant_show_off_bubble.active")
          .attr("data-handle");
        var selected_size1 = $(".Selector_buy_4")
          .find(".Selector_buy_41.Product_variant_size_selector_cell.active")
          .attr("data-title");
        var full_title = selected_color1 + "-" + selected_size1;
        var currentId;
        $(".Product_form_variant_checker__js").each(function () {
          if ($(this).attr("data-handle") == full_title) {
            currentId = $(this).attr("data-id");
          }
        });
  
        var selected_color2 = $(".Selector_buy_4")
          .find(".Selector_buy_42.Product_variant_show_off_bubble.active")
          .attr("data-handle");
        var selected_size2 = $(".Selector_buy_4")
          .find(".Selector_buy_42.Product_variant_size_selector_cell.active")
          .attr("data-title");
        var full_title2 = selected_color2 + "-" + selected_size2;
        var currentId2;
        $(".Product_form_variant_checker__js").each(function () {
          if ($(this).attr("data-handle") == full_title2) {
            currentId2 = $(this).attr("data-id");
          }
        });
  
        var selected_color3 = $(".Selector_buy_4")
          .find(".Selector_buy_43.Product_variant_show_off_bubble.active")
          .attr("data-handle");
        var selected_size3 = $(".Selector_buy_4")
          .find(".Selector_buy_43.Product_variant_size_selector_cell.active")
          .attr("data-title");
        var full_title3 = selected_color3 + "-" + selected_size3;
        var currentId3;
        $(".Product_form_variant_checker__js").each(function () {
          if ($(this).attr("data-handle") == full_title3) {
            currentId3 = $(this).attr("data-id");
          }
        });
  
        var selected_color4 = $(".Selector_buy_4")
          .find(".Selector_buy_44.Product_variant_show_off_bubble.active")
          .attr("data-handle");
        var selected_size4 = $(".Selector_buy_4")
          .find(".Selector_buy_44.Product_variant_size_selector_cell.active")
          .attr("data-title");
        var full_title4 = selected_color4 + "-" + selected_size4;
        var currentId4;
        $(".Product_form_variant_checker__js").each(function () {
          if ($(this).attr("data-handle") == full_title4) {
            currentId4 = $(this).attr("data-id");
          }
        });
        itemsToAdd.push({ id: currentId, quantity: 1 });
        itemsToAdd.push({ id: currentId2, quantity: 1 });
        itemsToAdd.push({ id: currentId3, quantity: 1 });
        itemsToAdd.push({ id: currentId4, quantity: 1 });
      }
  
      if (itemsToAdd.length > 0) {
        jQuery.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            items: itemsToAdd,
          },
          dataType: "json",
          success: function () {
            buildCart();

            $("body").addClass("Overflow_hidden");
            $("body").addClass("overflow-hidden");
            $('.nr_cart_drawer_outer').css('display', 'flex');

            setTimeout(function(){
                $('.nr_cart_drawer_outer').addClass('active');
            },100);
          },
        });
      }
    }
  }


  function addEucaliptBundle() {
    $(".Product_atc_button").text("Počakajte...");
    var itemsToAdd = []; // Array to store item IDs
    var mainItemId = $("");
    var mainItemId = $(".product-variant-id").attr("value");
    var bundleItemId = $(".Product_upsell_qty_value").attr("data-id");
    var bundleQuantity = parseFloat($(".Product_upsell_qty_value").text());
    itemsToAdd.push({ id: mainItemId, quantity: 1 });
    itemsToAdd.push({ id: bundleItemId, quantity: bundleQuantity });

    if (itemsToAdd.length > 0) {
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          items: itemsToAdd,
        },
        dataType: "json",
        success: function () {
          buildCart();
          setTimeout(function () {
            $(".Product_atc_button").text("Dodaj v košarico");
          }, 1000);

          $("body").addClass("Overflow_hidden");
          $("body").addClass("overflow-hidden");
          $('.nr_cart_drawer_outer').css('display', 'flex');
  
          setTimeout(function(){
              $('.nr_cart_drawer_outer').addClass('active');
          },100);
        },
      });
    }
  }

  function addEukaliptPillowUpsell() {
    var itemsToAdd = []; // Array to store item IDs
    $('.pdp_atc_text_upsell').text("Počakajte...");
    var mainItemId = $('.nlu_pa_price.active').attr('data-id');
    var bundleItemId = $('.nlu_pillow_select__js').val();
    itemsToAdd.push({ id: mainItemId, quantity: 1 });
    itemsToAdd.push({ id: bundleItemId, quantity: 1 });

    if (itemsToAdd.length > 0) {
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          items: itemsToAdd,
        },
        dataType: "json",
        success: function () {
          buildCart();
          setTimeout(function () {
            $('.pdp_atc_text_upsell').text("Dodaj v košarico");
          }, 1000);
          $("body").addClass("Overflow_hidden");
          $("body").addClass("overflow-hidden");
          $('.nr_cart_drawer_outer').css('display', 'flex');
  
          setTimeout(function(){
              $('.nr_cart_drawer_outer').addClass('active');
          },100);
        },
      });
    }
  }

  function addClassicItem() {
    $(".product-form .Product_atc_button").text("Počakajte...");
    var currentDeliveryDate = $('.delivery-hidden').attr('value');
    var currentQty = $(".quantity__input").val();
    var currentId = $(".product-variant-id").attr("value");
    var currentTitle = $(".product-variant-id").attr("data-title-main");
    var currentImage = $(".product-variant-id")
      .attr("data-img")
      .replace("http://127.0.0.1:9292", "https://noreo-lt.myshopify.com")
      .replace("//noreo.lt", "https://noreo-lt.myshopify.com");
    var currentProductId = $(".product-variant-id").attr("data-product-id");
    var currentUrl = window.location.href;

    var data_klaviyo = {
      ProductId: currentProductId,
      Name: currentTitle,
      ImageUrl: currentImage,
      items: {
        id: currentId,
        quantity: currentQty,
        variant_id: currentId,
        title: currentTitle,
        product_id: currentProductId,
        image: currentImage,
      },
      URL: currentUrl,
    };

    
      var data = {
        id: currentId,
        quantity: currentQty
      };
      console.log(data);
  
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function () {
          console.log(data);
          buildCart();
          gtag("event", "Clicked ATC", {
            event_label: "Clicked ATC Button",
            event_value: "Added To Cart",
          });
          console.log("Google analytics Added To Cart Event Triggered");
          _learnq.push(["track", "Added to Cart", data_klaviyo]);
          console.log(data_klaviyo, "Klaviyo event sent");
          setTimeout(function () {
          $(".product-form .Product_atc_button").text("Dodaj v košarico");
          }, 1000);

          $('.quantity__input').val(1);
          
          $("body").addClass("Overflow_hidden");
          $("body").addClass("overflow-hidden");
          $('.nr_cart_drawer_outer').css('display', 'flex');
  
          setTimeout(function(){
              $('.nr_cart_drawer_outer').addClass('active');
          },100);
        },
      });
  }


  function addClassicItemDetergent() {
    $(".product-form .Product_atc_button").text("Počakajte...");
    var currentDeliveryDate = $('.delivery-hidden').attr('value');
    var currentQty = $(".quantity__input").val();
    var currentId = $(".product-variant-id").attr("value");
    var currentTitle = $(".product-variant-id").attr("data-title-main");
    var currentImage = $(".product-variant-id")
      .attr("data-img")
      .replace("http://127.0.0.1:9292", "https://noreo-lt.myshopify.com")
      .replace("//noreo.lt", "https://noreo-lt.myshopify.com");
    var currentProductId = $(".product-variant-id").attr("data-product-id");
    var currentUrl = window.location.href;

    var data_klaviyo = {
      ProductId: currentProductId,
      Name: currentTitle,
      ImageUrl: currentImage,
      items: {
        id: currentId,
        quantity: currentQty,
        variant_id: currentId,
        title: currentTitle,
        product_id: currentProductId,
        image: currentImage,
      },
      URL: currentUrl,
    };

    
    if (currentQty == 1){
      var data = {
        id: currentId,
        quantity: currentQty
      };
      console.log(data);
  
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function () {
          console.log(data);
          buildCart();
          gtag("event", "Clicked ATC", {
            event_label: "Clicked ATC Button",
            event_value: "Added To Cart",
          });
          console.log("Google analytics Added To Cart Event Triggered");
          _learnq.push(["track", "Added to Cart", data_klaviyo]);
          console.log(data_klaviyo, "Klaviyo event sent");
          setTimeout(function () {
          $(".product-form .Product_atc_button").text("Dodaj v košarico");
          }, 1000);


          $('.quantity__input').val(1);
          
          $("body").addClass("Overflow_hidden");
          $("body").addClass("overflow-hidden");
          $('.nr_cart_drawer_outer').css('display', 'flex');
  
          setTimeout(function(){
              $('.nr_cart_drawer_outer').addClass('active');
          },100);
        },
      });
    }
    else if ( currentQty == 2 || currentQty == 3){
      var giftBogoId = 49501948838229;
      var giftId = 46859972903253;

      var data_arr = [];
      data_arr.push({
        id: giftId,
        quantity: 1,
      });
      data_arr.push({
        id: giftBogoId,
        quantity: 0,
      });
      data_arr.push({
        id: currentId,
        quantity: currentQty,
      });

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          items: data_arr,
        },
        dataType: "json",
        success: function (data) {
          // Do something on success
          console.log(data);
          buildCart();
          gtag("event", "Clicked ATC", {
            event_label: "Clicked ATC Button",
            event_value: "Added To Cart",
          });
          console.log("Google analytics Added To Cart Event Triggered");
          _learnq.push(["track", "Added to Cart", data_klaviyo]);
          console.log(data_klaviyo, "Klaviyo event sent");
          setTimeout(function () {
          $(".product-form  .Product_atc_button").text("Dodaj v košarico");
          }, 1000);

          $('.quantity__input').val(1);
  
          $("body").addClass("Overflow_hidden");
          $("body").addClass("overflow-hidden");
          $('.nr_cart_drawer_outer').css('display', 'flex');
  
          setTimeout(function(){
              $('.nr_cart_drawer_outer').addClass('active');
          },100);
        },
      }); 
    }
    else if ( currentQty > 3){
      var bogoQtyNew = Math.floor(currentQty / 2)
      var giftBogoId = 49501948838229;
      var giftId = 46859972903253;

      var data_arr = [];
      data_arr.push({
        id: giftId,
        quantity: 2,
      });
      data_arr.push({
        id: giftBogoId,
        quantity: bogoQtyNew,
      });
      data_arr.push({
        id: currentId,
        quantity: currentQty,
      });

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          items: data_arr,
        },
        dataType: "json",
        success: function (data) {
          // Do something on success
          console.log(data);
          buildCart();
          gtag("event", "Clicked ATC", {
            event_label: "Clicked ATC Button",
            event_value: "Added To Cart",
          });
          console.log("Google analytics Added To Cart Event Triggered");
          _learnq.push(["track", "Added to Cart", data_klaviyo]);
          console.log(data_klaviyo, "Klaviyo event sent");
          setTimeout(function () {
          $(".product-form  .Product_atc_button").text("Dodaj v košarico");
          }, 1000);

          $('.quantity__input').val(1);
  
          $("body").addClass("Overflow_hidden");
          $("body").addClass("overflow-hidden");
          $('.nr_cart_drawer_outer').css('display', 'flex');
  
          setTimeout(function(){
              $('.nr_cart_drawer_outer').addClass('active');
          },100);
        },
      }); 

    }
  }


  $(document).on("click",".Collection_product_card_atc_btn",function() {

    if ($(this).hasClass('disabled')){

    }
    else{

      $(this).find('.collection_atc_loader').show();
      $(this).find('.collection_atc_icon').hide();
      var currentSizeTitle = $(this).closest('.Collection_product_card').find('.Collection_product_card_btn.active').attr('data-title');
      var currentColorTitle = $(this).closest('.Collection_product_card').attr('data-color');
  
      var fullTitle = currentColorTitle + '-' + currentSizeTitle;
      var currentId = $(this).attr('data-id');
  
      $('.Collection_product_card_variant_checker_js').each(function(){
        if ($(this).attr('data-title') == fullTitle){
          currentId = $(this).attr('data-id');
        }
      });
  
      var data = {
        id: currentId,
        quantity: 1,
      };
  
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function () {
          console.log(data);
          buildCart();
          setTimeout(function () {
            $('.nr_cart_drawer_outer').css('display', 'flex');
            setTimeout(function(){
                $('.nr_cart_drawer_outer').addClass('active');
                $('.collection_atc_loader').hide();
                $('.collection_atc_icon').show();
            },100);
          }, 1000);
        },
      });

    }

  });



  $('.nr_pillow_upsell_selector').change(function(){

    var valueThis = $('.nr_upsell_selector__barva').val();
    if (valueThis == 'kreem' || valueThis == 'svetlo-siva'){
      console.log('value this');
      $('.nr_upsell_selector__velikost').find('option').show();
    }
    else{
      var valueDydis = $('.nr_upsell_selector__velikost').val();
      
      if (String(valueDydis).indexOf('91') != -1){
        $('.nr_pillow_upsell_selector.nr_upsell_selector__velikost').val('51x66-cm');
      }
      $('.nr_upsell_selector__velikost').find('option[value="51x91-cm"]').hide();
    }
    
    var currentTitle = '';
    $(this).closest('cart-upsell').find('.nr_pillow_upsell_selector').each(function(){
        var currentVal = $(this).val();
        currentTitle = currentTitle + '-' + currentVal;
    });

    currentTitle = currentTitle.substring(1);
    var currentId;
    var currentInv;

    $(this).closest('cart-upsell').find('.nr_pillow_upsell_price').hide();
    $(this).closest('cart-upsell').find('.nr_pillow_upsell_price').removeClass('active');
    $(this).closest('cart-upsell').find('.nr_pillow_upsell_price').each(function(){
        if ($(this).attr('data-title') == currentTitle){
            $(this).css('display', 'flex');
            $(this).addClass('active');
            currentId = $(this).attr('data-id');
            currentInv = $(this).attr('data-inv');
        }
    });

    if (currentInv == '1'){
      $(this).closest('cart-upsell').find('.nr_pillow_upsell_title').text('Dodaj');
    }
    else{
      $(this).closest('cart-upsell').find('.nr_pillow_upsell_title').text('Razprodano');
    }

    $(this).closest('cart-upsell').find('.nr_pillow_upsell_img_variant').hide();
    $(this).closest('cart-upsell').find('.nr_pillow_upsell_img_variant').each(function(){
      if ($(this).attr('data-id') == currentId){
        $(this).show();
      }
    });

    $(this).closest('cart-upsell').find('.nr_pillow_upsell_btn').attr('data-id', currentId);

    console.log(currentTitle, currentId, ' current title');

    jQuery.getJSON("/cart.js", function (cart) {
      var currency = "€";
      var pagalves = 0;
      var pagalvesPrice = 0;
      var pagalvesId = 'naravne-svile';
 
      for (var i = 0; i < cart.items.length; i++) {
        if (String(cart.items[i].handle).indexOf(pagalvesId) != -1){
            pagalves = pagalves + cart.items[i].quantity;
            pagalvesPrice = pagalvesPrice + cart.items[i].line_price;
        }
      }

      var pagalvesUpsellPrice = parseFloat($('.nr_cart_upsell_only_pillow .nr_pillow_upsell_price.active').attr('data-price'));
      var pagalvesForecastPrice = pagalvesPrice + pagalvesUpsellPrice;
      if (pagalves == 2){
        pagalvesForecastPrice = pagalvesForecastPrice * 0.9;
      }
      else if (pagalves > 3){
        pagalvesForecastPrice = pagalvesForecastPrice * 0.85;
      }
      pagalvesForecastPrice = ((pagalvesForecastPrice - pagalvesPrice)/100).toFixed(2);

      $('.nr_pillow_upsell_save__js').html(pagalvesForecastPrice + ' ' + currency);
    });
    
  });

  $('.nr_pillow_upsell_btn').click(function(){
    $(this).addClass('loading');
    var currentId = $(this).attr('data-id');
    var currentQty = 1;

    var data = {
        id: currentId,
        quantity: currentQty
      };
      console.log(data);
  
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function () {
          console.log(data);
          buildCart();
          setTimeout(function(){
            $('.nr_pillow_upsell_btn').removeClass('loading');
          },1000);
        },
      });
  });


  function cartUpsellsAndProgress(pagalves, kaukes, kepures, eukaliptas, skalbiklis){
    var message = '';
    var upsell_message = '';
    var upsells_headline = '';
    var percent = 0;

    console.log(pagalves, 'pagalves');
    if (eukaliptas > 0){
      if (pagalves == 0){
        percent = 70;
        message = 'Dodajte 1 prevleko za vzglavnik in pridobite: 10 % popusta, brezplačno dostavo in darilo.';
        upsell_message = 'Kupite skupaj!';
        upsells_headline = 'Popust na paket.';
        $('.nr_cart_upsell_only_pillow_eukalipt').css('display', 'flex');
        $('.nr_cart_upsell_only_pillow').hide();
        $('.nr_cart_upsell_produktai_only').hide();
      }
      else{
        percent = 100;
        message = 'Dodajte izdelke Noreo in pridobite do 30 % popusta!';
        upsell_message = 'Dodajte izdelke Noreo in pridobite do 30 % popusta!';
        upsells_headline = 'Kupite skupaj s prevleko za vzglavnik iz naravne svile Noreo:';
        $('.nr_cart_upsell_only_pillow_eukalipt').hide();
        $('.nr_cart_upsell_only_pillow').hide();
        $('.nr_cart_upsell_produktai_only').css('display', 'flex');
      }
      $('.nr_pillow_upsell_message__js').html(upsell_message);
    }
    else{
      if (pagalves == 0){
          message = 'Dodajte 2 prevleko za vzglavnik in pridobite: 10 % popusta, brezplačno dostavo in darilo.';
          upsells_headline = 'Popust na paket.';
          if ( skalbiklis > 0){
                percent = 25;
                
                $('.nr_cart_upsell_only_pillow').css('display', 'flex');
                $('.nr_cart_upsell_produktai_only').hide();
                $('.nr_cart_upsell_only_pillow_eukalipt').hide();
                upsell_message = '';
            }
          else{
            if (kaukes > 0 || kepures > 0){
                percent = 50;
                
                $('.nr_cart_upsell_only_pillow').css('display', 'flex');
                $('.nr_cart_upsell_produktai_only').hide();
                upsell_message = 'Kupite skupaj s prevleko za vzglavnik iz naravne svile Noreo:';
            }
            if (eukaliptas > 0){
                percent = 70;
                $('.nr_cart_upsell_only_pillow').css('display', 'flex');
                $('.nr_cart_upsell_produktai_only').hide();
                upsell_message = 'Kupite skupaj s prevleko za vzglavnik iz naravne svile Noreo:';
            }
          }
          $('.nr_pillow_upsell_save__js').hide();
          $('.nr_pillow_upsell_label').hide();
      }   
      else{
          $('.nr_pillow_upsell_save__js').show();
          $('.nr_pillow_upsell_label').show();
          if (pagalves == 1){
              upsell_message = '+ 10 % popust na enoto.<br>+ Brezplačna dostava<br>';
              message = 'Dodajte 1 prevleko za vzglavnik in dobite: 10% popust + brezplačna dostava in darilo';
              upsells_headline = 'Izkoristite te posebne ponudbe:';
              percent = 35;
              $('.nr_cart_upsell_only_pillow').css('display', 'flex');
              $('.nr_cart_upsell_produktai_only').hide();
              $('.nr_cart_upsell_only_pillow_eukalipt').hide();
          }
          if (pagalves == 2){
              message = 'Dodajte 2 pokrova in dobite: 15% popust + brezplačna dostava in 2 darila';
              upsells_headline = 'Izkoristite te posebne ponudbe:';
              percent = 55;
              upsell_message = '+ 10 % popust na enoto.<br>+ Brezplačna dostava<br>';
              $('.nr_cart_upsell_only_pillow').hide();
              $('.nr_cart_upsell_produktai_only').css('display', 'flex');
              $('.nr_cart_upsell_only_pillow_eukalipt').hide();
          }
          if (pagalves == 3){
              message = 'Dodajte 1 prevleko za vzglavnik in dobite: 15% popust + brezplačna dostava in 2 darili';
              upsells_headline = 'Izkoristite te posebne ponudbe:';
              percent = 75;
              upsell_message = '+ 15 % popust na enoto.<br>+ Brezplačna dostava<br>';
              $('.nr_cart_upsell_only_pillow').hide();
              $('.nr_cart_upsell_produktai_only').css('display', 'flex');
              $('.nr_cart_upsell_only_pillow_eukalipt').hide();
          }
          if (pagalves > 3){
              message = 'Dobili boste 15-odstotni popust, brezplačno dostavo in dve darili!';
              upsells_headline = 'Izkoristite te posebne ponudbe:';
              upsell_message = '+ 15 % popust na enoto.<br>+ Brezplačna dostava<br>';
              $('.nr_cart_upsell_only_pillow').hide();
              $('.nr_cart_upsell_produktai_only').css('display', 'flex');
              $('.nr_cart_upsell_only_pillow_eukalipt').hide();
              if (kaukes > 0 || kepures > 0 ){
                  percent = 100;
              }
              else{
                  percent = 85;
              }
          }
      }
    }
    
    $('.nr_cart_progress').find('p').text(message);
    $('.nr_cart_progress_inner').css('width', percent + '%');
    $('.nr_pillow_upsell_message__js').html(upsell_message);
    $('.nr_cart_upsell_label p').html(upsells_headline);
    console.log(upsells_headline);
  }


  $('.nr_cart_checkout_btn').click(function(){
    window.location.href = '/checkout';
  });



  var countDownDate = new Date();
  countDownDate.setMinutes(countDownDate.getMinutes() + 15); // Set countdown to 15 minutes from now

  var x = setInterval(function() {
      var now = new Date().getTime();
      var distance = countDownDate - now;

      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      $(".hours").text(hours);
      $(".nr_cart_timer__min").text(minutes);
      $(".nr_cart_timer__sek").text(seconds);

      if (distance < 0) {
          clearInterval(x);
          $(".hours").text('0');
          $(".nr_cart_timer__min").text('0');
          $(".nr_cart_timer__sek").text('0');
          $('.nr_cart_timer p').text('00');
      }
  }, 1000);


$('.detu_atc').click(function(){
    $(this).addClass('loading');
    
    var currentId = $(this).attr('data-id');
    var currentQty = parseFloat($(this).closest('.detu_inn').find('.detu_qty_val').html());
    var items = [];
    items.push({ id: currentId, quantity: currentQty });
  
    console.log(items);
  
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        items: items,
      },
      dataType: "json",
      success: function (data) {
        // Do something on success
        console.log(data);
        buildCart();
        setTimeout(function () {
          $('.nr_cart_drawer_outer').css('display', 'flex');
  
          setTimeout(function(){
              $('.nr_cart_drawer_outer').addClass('active');
              $("body").addClass("Overflow_hidden");
              $("body").addClass("overflow-hidden");
      
          },100);
          $('.detu_atc').removeClass('loading');
        }, 1000);
      },
    }); 
    
  });


    $('.pke_atc_btn').click(function(){
      var currentQty = 1;
      var currentId = $(this).attr("data-id");
      
    
      var data = {
        id: currentId,
        quantity: currentQty
      };
    
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function () {
          console.log(data);
          buildCart();
    
          $("body").addClass("Overflow_hidden");
          $("body").addClass("overflow-hidden");
          $('.nr_cart_drawer_outer').css('display', 'flex');
          $('.gs_loader_outer').hide();
          $('.gs_atc_icon').show();
    
          setTimeout(function(){
              $('.nr_cart_drawer_outer').addClass('active');
          },100);
        },
      });
      
    });


  $('.Slide_cart_agree_line').click(function(){
    $(this).toggleClass('active');
  });

$('.product-main__atc-wrapper #add-to-cart-button').click(function (e) {
  e.preventDefault();

  const selectedProduct = $('.product-main__product.active');
  const quantity = $('.active .product-main__quantity-selector .quantity-num').data('quantity') || $('.product-main__atc-wrapper .product-main__quantity-selector .quantity-num').data('quantity') || 1;
  let items = [];
  let id = selectedProduct.data('id');

  items.push({ id, quantity })
  if (selectedProduct.hasClass('special')) {
    const selectedColor = $('.product-colors .Color_selector.active').data('color');
    const selectedSize = $('.product-sizes .Size_selector.active').data('size');

    const productData = $(`#variants-data .variant-data[data-color="${selectedColor}"][data-size="${selectedSize}"]`);
    const id = productData.data('id');
    items.push({ id, quantity })
  }

  const data = items.length > 1 ? { items } : items[0];
  console.log(data);
  postToCart(data);
})

function postToCart(data) {
  $.post("/cart/add.js", data, function () {
    buildCart();
    setTimeout(function () {
      $('.nr_cart_drawer_outer').css('display', 'flex');
      setTimeout(function () {
        $('.nr_cart_drawer_outer').addClass('active');
        $("body").addClass("Overflow_hidden");
        $("body").addClass("overflow-hidden");
      }, 100);
    }, 1000);
  }).fail((err) => alert('Error adding the items to the cart.'));
}